import { RouterModule, Routes } from '@angular/router'

import { LoggedOutComponent } from './login/loggedout.component'
import { LoginComponent } from './login/login.component'

import { AsiakasGuard } from './_angular/_guards/asiakas.guard'
import { AuthGuard } from './_angular/_guards/auth.guard'
import { NakymaGuard } from './_angular/_guards/nakyma.guard'
import { TiimiGuard } from './_angular/_guards/tiimi.guard'
import { TilintarkastajaAsiakasGuard } from './_angular/_guards/tilintarkastaja-asiakas.guard'
import { TilintarkastajaAuthGuard } from './_angular/_guards/tilintarkastaja-auth.guard'
import { YberYllapitoGuard } from './_angular/_guards/yber-yllapito.guard'
import { YllapitoGuard } from './_angular/_guards/yllapito.guard'
import { SALLITUT_LLM_TESTAUS_UIDT } from './_angular/service/kirjautunut-kayttaja.service'
import { KirjanpitajaTiimiAvaimet } from './_jaettu-lemonator/model/kirjanpitaja'

import {
  AsiakasComponentDataResolve,
  KayttajaComponentDataResolve,
  KirjanpitoComponentDataResolve,
  TilintarkastajaAsiakasComponentDataResolve,
  TilintarkastajaKirjanpitoComponentDataResolve,
} from './_angular/_resolvers/asiakas.resolve'
import { AsiakasLisaaComponent } from './asiakkaat/asiakas-lisaa.component'
import { AsiakkaanKayttajatComponent } from './asiakkaat/asiakkaan-kayttajat.component'
import { AsiakkaanMaksutavatComponent } from './asiakkaat/asiakkaan-maksutavat.component'
import { AsiakkaanTositteetComponent } from './asiakkaat/asiakkaan-tositteet.component'
import { KayttajaComponent } from './asiakkaat/kayttaja.component'
import { AsiakkaatComponent } from './asiakkaat/listaus/asiakkaat.component'

import { AsiakasAsetuksetAsiakastiedotComponent } from './asiakkaat/asetukset/asiakastiedot.component'
import { AsiakasAsetuksetKirjanpitotiedotComponent } from './asiakkaat/asetukset/kirjanpitotiedot.component'
import { AsiakasAsetuksetLaskutusComponent } from './asiakkaat/asetukset/laskutus.component'
import { AsiakasAsetuksetSopimuskaudetV2Component } from './asiakkaat/asetukset/sopimuskaudet-v2.component'

import { AsiakasAsetuksetTuntemistiedotComponent } from './asiakkaat/asetukset/tuntemistiedot/tuntemistiedot.component'

import { AjopaivakirjaContainerComponent } from './asiakkaat/ajopaivakirja/ajopaivakirja-container.component'

import { AsiakkaanKirjanpitoLahetyksetComponent } from './asiakkaat/yllapito/kirjanpito-lahetykset.component'
import { TilastotTiimaritComponent } from './tilastot/tilastot-tiimarit.component'
import { TilastotComponent } from './tilastot/tilastot.component'

import { LaskuComponentDataResolve, LaskuKatseleComponentDataResolve, LaskuSelaaKatseleComponentDataResolve } from './_angular/_resolvers/lasku.resolve'
import { TositeKatseleComponentDataResolve } from './_angular/_resolvers/tosite.resolve'
import { LaskuComponent } from './laskut/lasku.component'
import { LaskuKatseleComponent } from './laskut/lasku.katsele.component'
import { TositeSelailuKatseleComponent } from './tositteet/selailu/tosite.katsele.component'
import { TositeSelailuListausComponent } from './tositteet/selailu/tosite.listaus.component'
import { YhteisomyyntilaskutComponent } from './yllapito/yhteisomyyntilaskut.component'

import { HolviImportComponent } from './yllapito/holvi-import/holvi-import.component'
import { TilitapahtumatComponent } from './yllapito/tilitapahtumat/tilitapahtumat.component'

import { KirjanpitajaComponentDataResolve } from './_angular/_resolvers/kirjanpitaja.resolve'
import { KirjanpitajaComponent } from './yllapito/kirjanpitajat/kirjanpitaja.component'
import { KirjanpitajatComponent } from './yllapito/kirjanpitajat/kirjanpitajat.component'
import { TiimikokonaisuudetComponent } from './yllapito/tiimit/tiimikokonaisuudet/tiimikokonaisuudet.component'
import { TiimitComponent } from './yllapito/tiimit/tiimit.component'

import { AsiakkaanApixLaskujenTiedotComponent } from './asiakkaat/yllapito/apix-laskujen-tiedot.component'
import { AsiakkaanLemonaidLaskuasetuksetComponent } from './asiakkaat/yllapito/lemonaid-laskuasetukset.component'

import { KirjanpitoComponent } from './kirjanpito/kirjanpito.component'
import { KirjanpitoRaportitStandaloneComponent } from './kirjanpito/raportit-standalone.component'
import { KirjanpitoTositeStandaloneComponent } from './kirjanpito/tositteet/tosite-standalone.component'
import { KirjanpitoTilintarkastusComponent } from './tilintarkastajat/kirjanpito/tilintarkastus-kirjanpito.component'

import { PaatilikarttaComponent } from './yllapito/tilikartta/paatilikartta.component'
// import { AsiakkaanTilikarttaComponent } from './asiakkaxat/tilikartta/asiakkaan-tilikartta.component'
import { AsiakkaatComponentOld } from './asiakkaat/listaus/asiakkaat.component-old'
import { AsiakkaanKirjanpidonAlustaminenComponent } from './asiakkaat/yllapito/kirjanpidon-alustaminen.component'
import { AsiakasOmaveroMaksutiedotComponent } from './asiakkaat/yllapito/omavero-maksutiedot.component'
import { YhteisomyyntiIlmoituksetComponent } from './asiakkaat/yllapito/yhteisomyynti-ilmoitukset.component'
import { KirjanpitoAineistonLatausComponent } from './kirjanpito/aineiston-lataus/kirjanpito-aineiston-lataus.component'
import { YllapitoHolviComponent } from './yllapito/integraatiot/holvi.component'
import { YllapitoVerohallintoComponent } from './yllapito/integraatiot/verohallinto.component'
import { PankkiyhteydetComponent } from './yllapito/pankkiyhteydet/pankkiyhteydet.component'
import { ReportsComponent } from './yllapito/raportit/reports.component'
import { SopimuksetComponent } from './yllapito/sopimukset/sopimukset.component'
import { PaivasaldoListausComponent } from './yllapito/tilitapahtumat/paivasaldot-listaus.component'
import { TilitapahtumienKohdistusdebugComponent } from './yllapito/tilitapahtumat/tilitapahtumien-kohdistusdebug.component'

import { MoniyritystukiComponentDataResolve } from 'app/_angular/_resolvers/moniyritystuki.resolve'
import { TilintarkastajaComponentDataResolve } from 'app/_angular/_resolvers/tilintarkastaja.resolve'
import { TuonnitComponent } from 'app/asiakkaat/asetukset/import/tuonnit.component'
import { LemonatorNakyma } from './_jaettu-lemonator/model/lemonator-nakyma'
import { ArkistoSisainenComponent } from './asiakkaat/arkisto-sisainen/arkisto-sisainen.component'
import { AsiakasTyojonoLoadingDetailsComponent } from './asiakkaat/asetukset/asiakas-tyojono-loading-details.component'
import { AsiakashakuComponent } from './asiakkaat/asiakashaku.component'
import { AsiakasSalesListComponent } from './asiakkaat/sales.component'
import { AjastetutTyotComponent } from './asiakkaat/yllapito/ajastetut-tyot.component'
import { BankConnectionsComponent } from './asiakkaat/yllapito/bank-connections.component'
import { KirjanpitajanAsetuksetComponent } from './kirjanpitaja/kirjanpitajan-asetukset.component'
import { LaskuAsiakasSelaaKatseleComponent } from './laskut/selaa/lasku-asiakas-selaa.katsele.component'
import { LaskuAsiakkaatSelaaComponent } from './laskut/selaa/lasku-asiakkaat-selaa.component'
import { LaskuSelaaKatseleComponent } from './laskut/selaa/lasku-selaa.katsele.component'
import { LaskutSelaaComponent } from './laskut/selaa/laskut-selaa.component'
import { OstolaskuSelaaKatseleComponent } from './laskut/selaa/ostolasku-selaa.katsele.component'
import { OstolaskutSelaaComponent } from './laskut/selaa/ostolaskut-selaa.component'
import { ToimittajaSelaaKatseleComponent } from './laskut/selaa/toimittaja-selaa.katsele.component'
import { ToimittajatSelaaComponent } from './laskut/selaa/toimittajat-selaa.component'
import { TuoteSelaaKatseleComponent } from './laskut/selaa/tuote-selaa.katsele.component'
import { TuotteetSelaaComponent } from './laskut/selaa/tuotteet-selaa.component'
import { ToistuvatLaskutSelaaComponent } from './laskut/toistuvat-laskut-selaa.component'
import { TilintarkastajaAloitusComponent } from './tilintarkastajat/aloitus/tilintarkastaja-aloitus.component'
import { TilintarkastajaKirjautuminenComponent } from './tilintarkastajat/kirjautuminen/tilintarkastaja-kirjautuminen.component'
import { TilintarkastajaTunnistautuminenComponent } from './tilintarkastajat/tunnistautuminen/tilintarkastaja-tunnistautuminen.component'
import { TunnistautuminenNetsReturnComponent } from './tunnistautuminen/nets/nets-return.component'
import { YllapitoAjastetutTyotComponent } from './yllapito/ajastetut-tyot/yllapito-ajastetut-tyot.component'
import { EmailTemplatesComponent } from './yllapito/email-templates/email-templates.component'
import { ItTyopoytaComponent } from './yllapito/it-tyopoyta/it-tyopoyta.component'
import { LlmKirjausehdotusTestausComponent } from './yllapito/llm-kirjausehdotus-testaus/llm-kirjausehdotus-testaus.component'
import { LemonaidViestitComponent } from './yllapito/lemonaid-viestit/lemonaid-viestit.component'
import { LoggingComponent } from './yllapito/logging/logging.component'
import { MaksumuistutusComponent } from './yllapito/maksumuistutus/maksumuistutus.component'
import { MoniyritystuetComponent } from './yllapito/moniyritystuet/moniyritystuet.component'
import { MoniyritystukiComponent } from './yllapito/moniyritystuet/moniyritystuki.component'
import { PushIlmoitusTyokaluComponent } from './yllapito/push-ilmoitukset/push-ilmoitus-tyokalu.component'
import { TagitComponent } from './yllapito/tagit/tagit.component'
import { TilastonSiirtoTyokaluComponent } from './yllapito/tilastot/tilaston-siirto-tyokalu.component'
import { TilintarkastajaComponent } from './yllapito/tilintarkastajat/tilintarkastaja.component'
import { TilintarkastajatComponent } from './yllapito/tilintarkastajat/tilintarkastajat.component'

const appRoutes: Routes = [
  { path: '', component: AsiakkaatComponent, canActivate: [AuthGuard] },

  // Asiakkaat, käyttäjätyökalut
  {
    path: 'asiakkaat/:asiakasAvain/kayttajat/:kayttajaAvain',
    component: KayttajaComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: KayttajaComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.KAYTTAJAT, description: 'Asiakas: Käyttäjän henkilötiedot/roolit' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/kayttajat',
    component: AsiakkaanKayttajatComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.KAYTTAJAT, description: 'Asiakas: Käyttäjät listaus' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/maksutavat',
    component: AsiakkaanMaksutavatComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.MAKSUTAVAT, description: 'Asiakas: Maksutavat' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/laskuasetukset',
    component: AsiakkaanLemonaidLaskuasetuksetComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.LASKUASETUKSET, description: 'Asiakas: Laskuasetukset' },
  },

  // Asiakkaat, tositteiden selaaminen
  {
    path: 'asiakkaat/:asiakasAvain/tositteet/selaa/:tositeAvain',
    component: TositeSelailuKatseleComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: TositeKatseleComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.TOSITTEET_SELAA, description: 'Asiakas: Katsele tositetta' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/tositteet/selaa',
    component: TositeSelailuListausComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.TOSITTEET_SELAA, description: 'Asiakas: Selaa tositteita' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/tositteet/lataa',
    component: AsiakkaanTositteetComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.TOSITTEET_LATAA, description: 'Asiakas: Lataa tositteita - Lataa palkkatositteet, käynnistä palkkojen haku' },
  },

  // Asiakkaat, laskujen selaaminen
  {
    path: 'asiakkaat/:asiakasAvain/laskut/selaa/:id/:kasiteltavaAvain/:toiminto',
    component: LaskuSelaaKatseleComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: LaskuSelaaKatseleComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.LASKUT_SELAA, description: 'Asiakas: Äsken luodun laskun katselu' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/laskut/selaa/:id/:kasiteltavaAvain',
    component: LaskuSelaaKatseleComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: LaskuSelaaKatseleComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.LASKUT_SELAA, description: 'Asiakas: Myyntilaskun katselu' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/laskut/selaa',
    component: LaskutSelaaComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.LASKUT_SELAA, description: 'Asiakas: Lähetetyt myyntilaskut listaus' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/tuotteet/selaa/:tuoteAvain',
    component: TuoteSelaaKatseleComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.TUOTTEET_SELAA, description: 'Asiakas: Yksittäisen tuotteen katselu' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/tuotteet/selaa',
    component: TuotteetSelaaComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.TUOTTEET_SELAA, description: 'Asiakas: Tuotteiden selaus' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/lasku-asiakkaat/selaa/:laskunAsiakasAvain',
    component: LaskuAsiakasSelaaKatseleComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.LASKU_ASIAKKAAT_SELAA, description: 'Asiakas: Yksittäisen laskunasiakkaan katselu' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/lasku-asiakkaat/selaa',
    component: LaskuAsiakkaatSelaaComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.LASKU_ASIAKKAAT_SELAA, description: 'Asiakas: Laskunasiakkaiden selaus' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/ostolaskut/selaa/:laskuAvain',
    component: OstolaskuSelaaKatseleComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.OSTOLASKUT_SELAA, description: 'Asiakas: Yksittäisen ostolaskun katselu' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/ostolaskut/selaa',
    component: OstolaskutSelaaComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.OSTOLASKUT_SELAA, description: 'Asiakas: Ostolaskujen selaus' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/toimittajat/selaa/:toimittajaAvain',
    component: ToimittajaSelaaKatseleComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.TOIMITTAJAT_SELAA, description: 'Asiakas: Yksittäisen toimittajan katselu' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/toimittajat/selaa',
    component: ToimittajatSelaaComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.TOIMITTAJAT_SELAA, description: 'Asiakas: Toimittajien selaus' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/laskut/toistuvat',
    component: ToistuvatLaskutSelaaComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.LASKUT_TOISTUVAT, description: 'Asiakas: Toistuvat laskut listaus' },
  },

  // Asiakkaat, asetukset, laskujen lähettäminen
  {
    path: 'asiakkaat/:asiakasAvain/laskutus/katsele/:id/:kasiteltavaAvain/:toiminto',
    component: LaskuKatseleComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: LaskuKatseleComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.LASKUTUS, description: 'Asiakas, asetukset: Tehty toiminto laskutuksessa' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/laskutus/katsele/:id/:kasiteltavaAvain',
    component: LaskuKatseleComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: LaskuKatseleComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.LASKUTUS, description: 'Asiakas, asetukset: Katsele asiakkaalle lähetettyä Lemontreen laskua' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/laskutus/luo/:id/:kasiteltavaAvain',
    component: LaskuComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: LaskuComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.LASKUTUS, description: 'Asiakas, asetukset: Luo uusi Lemontreen kirjanpidon kertalasku tai hyvityslasku asiakkaalle' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/laskutus',
    component: AsiakasAsetuksetLaskutusComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.LASKUTUS, description: 'Asiakas, asetukset: Laskutuksen asetukset, lähetetyt laskut asiakkaalle' },
  },

  // Asiakkaat, asetukset, muut
  {
    path: 'asiakkaat/:asiakasAvain/kirjanpitotiedot',
    component: AsiakasAsetuksetKirjanpitotiedotComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.KIRJANPITOTIEDOT, description: 'Asiakas, asetukset: Kirjanpitotiedot - ALV, Tilikaudet, Kirjanpidon peruste, Omaverotäsmäytys jne.' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/asiakastiedot',
    component: AsiakasAsetuksetAsiakastiedotComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.ASIAKASTIEDOT, description: 'Asiakas, asetukset: Asiakkaan henkilötiedot ja kirjanpitotietoja' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/tuntemistiedot',
    component: AsiakasAsetuksetTuntemistiedotComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: {
      nakymaAvain: LemonatorNakyma.TUNTEMISTIEDOT,
      description: 'Asiakas, asetukset: Tuntemistiedot -> Edustaja, YTJ, Sopimukset, Kuvaus toiminnasta, Riskiarvio, Osakkaat, Hallitus ja toimitusjohtaja, Tosiasialliset edunsaajat',
    },
  },
  {
    path: 'asiakkaat/:asiakasAvain/kirjanpidon-ulkopuoliset-vahennykset',
    component: AjopaivakirjaContainerComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.KIRJANPIDON_ULKOPUOLISET_VAHENNYKSET, description: 'Asiakas: Kirjanpidon ulkopuoliset vähennykset' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/veronmaksu',
    component: AsiakasOmaveroMaksutiedotComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.VERONMAKSU, description: 'Asiakas: Veron maksu, viitenumerot, ennakkoveron maksuohjelma' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/sopimukset',
    component: AsiakasAsetuksetSopimuskaudetV2Component,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.SOPIMUKSET, description: 'Asiakas, asetukset: Sopimuskaudet' },
  },
  // { path: 'asiakkaat/:asiakasAvain/sopimus', component: AsiakasAsetuksetSopimuskaudetV2Component, canActivate: [AsiakasGuard], resolve: { 'data': AsiakasComponentDataResolve }, data: { description: 'Asiakas, asetukset: Sopimuskaudet' } },
  {
    path: 'asiakkaat/:asiakasAvain/sisainen-arkisto',
    component: ArkistoSisainenComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.SISAINEN_ARKISTO, description: 'Asiakas: Sisäiset dokumentit' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/ajastetut-tyot',
    component: AjastetutTyotComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.AJASTETUT_TYOT, description: 'Asiakas: Ajastetut työt' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/lataus-tyot',
    component: AsiakasTyojonoLoadingDetailsComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.LATAUS_TYOT, description: 'Asiakas: Keskeneräiset lataukset' },
  },
  // Päänäkymät
  {
    path: 'jaettavat-asiakkaat',
    component: AsiakasSalesListComponent,
    canActivate: [AuthGuard, NakymaGuard],
    data: { nakymaAvain: LemonatorNakyma.JAETTAVAT_ASIAKKAAT, description: 'Jaettavat asiakkaat lista' },
  },
  { path: 'tilastot', component: TilastotComponent, canActivate: [AuthGuard], data: { description: 'Kuukausitilastot' } },
  { path: 'tiimitilastot', component: TilastotTiimaritComponent, canActivate: [AuthGuard, YllapitoGuard], data: { description: 'Tiimitilastot' } },
  { path: 'asiakkaat/uusi', component: AsiakasLisaaComponent, canActivate: [AuthGuard], data: { description: 'Luo uusi asiakas henkilötiedoilla' } },
  { path: 'asiakkaat/haku', component: AsiakashakuComponent, canActivate: [AuthGuard, NakymaGuard], data: { nakymaAvain: LemonatorNakyma.ASIAKASHAKU, description: 'Hae asiakasta tietokannasta' } },
  { path: 'asiakkaat', component: AsiakkaatComponent, canActivate: [AuthGuard], data: { description: 'Työlista - asiakaslistaus', lista: 'tyolista' } },
  { path: 'asiakkaat/kasvu', component: AsiakkaatComponent, canActivate: [AuthGuard], data: { description: 'Työlista (Kasvu) - asiakaslistaus', lista: 'kasvu' } },
  { path: 'asiakkaat/fivaldi', component: AsiakkaatComponentOld, canActivate: [AuthGuard], data: { description: 'Työlista (Fivaldi) - työlista', lista: 'fivaldi' } },
  { path: 'zen', component: AsiakkaatComponent, canActivate: [AuthGuard], data: { description: 'ZEN - asiakaslistaus' } },
  { path: 'kirjanpitajan-asetukset', component: KirjanpitajanAsetuksetComponent, canActivate: [AuthGuard], data: { description: 'Kirjanpitäjän asetukset, tiedot, allekirjoitus' } },
  { path: 'it-tyopoyta', component: ItTyopoytaComponent, canActivate: [YberYllapitoGuard], data: { description: 'IT-tiimin työpöytä' } },

  // Kirjanpito
  // { path: 'asiakkaat/:asiakasAvain/tilikartta', component: AsiakkaanTilikarttaComponent, canActivate: [AsiakasGuard], resolve: { 'data': AsiakasComponentDataResolve } },
  {
    path: 'asiakkaat/:asiakasAvain/kirjanpito/:vuosi/:kuukausi/:valilehti',
    component: KirjanpitoComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: KirjanpitoComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.KIRJANPITO, description: 'Kirjanpito: vuosi/kuukausi + tiedot' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/kirjanpito/:vuosi/:kuukausi',
    component: KirjanpitoComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: KirjanpitoComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.KIRJANPITO, description: 'Kirjanpito: vuosi/kuukausi' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/kirjanpito',
    component: KirjanpitoComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: KirjanpitoComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.KIRJANPITO, description: 'Kirjanpito' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/kirjanpidon-raportit/:vuosi/:kuukausi/:tyyppi',
    component: KirjanpitoRaportitStandaloneComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.KIRJANPITO, description: 'Kirjanpito/Raportit - vuosi, kuukausi, tyyppi' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/kirjanpidon-tosite/:tositeTyyppi/:tositeAvain',
    component: KirjanpitoTositeStandaloneComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.KIRJANPITO, description: 'Kirjanpidon tosite' },
  },

  // Asiakaskohtaiset ylläpitotyökalut
  {
    path: 'asiakkaat/:asiakasAvain/yllapito/apixlaskut',
    component: AsiakkaanApixLaskujenTiedotComponent,
    canActivate: [AsiakasGuard, YllapitoGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.APIX_LASKUT, description: 'Asiakas: APIX tiedot' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/tilitapahtumat/kohdistusdebug',
    component: TilitapahtumienKohdistusdebugComponent,
    canActivate: [AsiakasGuard, YllapitoGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.RESKONTRA_DEBUG, description: 'Asiakas: Reskontra debug' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/tilitapahtumat',
    component: TilitapahtumatComponent,
    canActivate: [AsiakasGuard, YllapitoGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.TILITAPAHTUMAT, description: 'Asiakas: Tilitapahtumat listaus' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/pankkiyhteydet',
    component: BankConnectionsComponent,
    canActivate: [AsiakasGuard, YllapitoGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.PANKKIYHTEYDET, description: 'Asiakas: Pankkiyhteysvaltuutuksen tila/Aiia/Holvi' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/lahetykset',
    component: AsiakkaanKirjanpitoLahetyksetComponent,
    canActivate: [AsiakasGuard, YllapitoGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.KIRJANPIDON_LAHETYKSET, description: 'Asiakas: Asiakkaalle lähetetyt kirjanpitosähköpostit' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/paivasaldot',
    component: PaivasaldoListausComponent,
    canActivate: [AsiakasGuard, YllapitoGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.PAIVASALDOT, description: 'Asiakas: Päiväsaldot' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/aineiston-lataus',
    component: KirjanpitoAineistonLatausComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.AINEISTON_LATAUS, description: 'Asiakas: Aineiston lähetys' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/holvi-import',
    component: HolviImportComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.HOLVI_IMPORT, description: 'Asiakas: Holvi-aineiston lataaminen' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/alusta-kirjanpito',
    component: AsiakkaanKirjanpidonAlustaminenComponent,
    canActivate: [AsiakasGuard, YllapitoGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.ALUSTA_KIRJANPITO, description: 'Asiakas: Kirjanpidon alustaminen (kevyt, tavallinen)' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/tuonnit',
    component: TuonnitComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.TUONNIT, description: 'Asiakas: Tuonnit' },
  },
  {
    // Vanha suora URL — säilytetään jotta hallintokansion arkistoTiedostonAvain-flow ja bookmarkit toimivat.
    // TuonnitComponent päättelee URL:n perusteella oikean välilehden.
    path: 'asiakkaat/:asiakasAvain/alkusaldo-import',
    component: TuonnitComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.TUONNIT, description: 'Asiakas: Alkusaldojen tuonti (legacy URL)' },
  },
  {
    // Vanha suora URL — säilytetään yhteensopivuuden vuoksi.
    path: 'asiakkaat/:asiakasAvain/tuote-import',
    component: TuonnitComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.TUONNIT, description: 'Asiakas: Tuotteiden tuonti (legacy URL)' },
  },
  {
    // Asiakkaiden import suorana URL:na — käytetään hallintokansion linkityksessä.
    path: 'asiakkaat/:asiakasAvain/asiakas-import',
    component: TuonnitComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.TUONNIT, description: 'Asiakas: Laskunasiakkaiden tuonti' },
  },
  {
    // Toimittajien import suorana URL:na — käytetään hallintokansion linkityksessä.
    path: 'asiakkaat/:asiakasAvain/toimittaja-import',
    component: TuonnitComponent,
    canActivate: [AsiakasGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.TUONNIT, description: 'Asiakas: Toimittajien tuonti' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/yhteisomyynti-ilmoitukset',
    component: YhteisomyyntiIlmoituksetComponent,
    canActivate: [AsiakasGuard, YllapitoGuard, NakymaGuard],
    resolve: { data: AsiakasComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.YHTEISOMYYNTI_ILMOITUKSET, description: 'Asiakas: Lähetetyt yhteisömyynti-ilmoitukset' },
  },

  // Kaikille supereille
  {
    path: 'yllapito/raportit',
    component: ReportsComponent,
    canActivate: [YllapitoGuard, NakymaGuard],
    data: { nakymaAvain: LemonatorNakyma.YLLAPITO_RAPORTIT, description: 'Ylläpito: Raportit (ladattavat) - Myyntiraportti, Päättyneet sopimukset..' },
  },
  {
    path: 'yllapito/tilintarkastajat',
    component: TilintarkastajatComponent,
    canActivate: [YllapitoGuard, NakymaGuard],
    data: { nakymaAvain: LemonatorNakyma.YLLAPITO_TILINTARKASTAJAT, description: 'Ylläpito: Tilintarkastajat' },
  },
  {
    path: 'yllapito/tagit',
    component: TagitComponent,
    canActivate: [YllapitoGuard, NakymaGuard],
    data: { nakymaAvain: LemonatorNakyma.YLLAPITO_TAGIT, description: 'Ylläpito: Tagit' },
  },
  {
    path: 'yllapito/tilintarkastajat/:avain',
    component: TilintarkastajaComponent,
    canActivate: [YllapitoGuard, NakymaGuard],
    resolve: { data: TilintarkastajaComponentDataResolve },
    data: { nakymaAvain: LemonatorNakyma.YLLAPITO_TILINTARKASTAJAT, description: 'Ylläpito: Tilintarkastajan tiedot' },
  },

  // Vain jos super + tiimi on MUUT, KAYTTOTUKI, IT tai GENOVA
  {
    path: 'yllapito/massamuikkarit',
    component: MaksumuistutusComponent,
    canActivate: [YllapitoGuard, TiimiGuard, NakymaGuard],
    data: {
      nakymaAvain: LemonatorNakyma.YLLAPITO_MASSAMUIKKARIT,
      sallitutTiimit: [KirjanpitajaTiimiAvaimet.MUUT, KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT, KirjanpitajaTiimiAvaimet.GENOVA],
      description: 'Ylläpito: Maksumuistutuksien massalähetyslistaus',
    },
  },

  // Yleinen ylläpito, vain jos super + tiimi on MUUT, KAYTTOTUKI tai IT                                                                                                                          // Tarja Nieminen
  {
    path: 'yllapito/paatilikartta',
    component: PaatilikarttaComponent,
    canActivate: [YllapitoGuard, TiimiGuard, NakymaGuard],
    data: {
      nakymaAvain: LemonatorNakyma.YLLAPITO_PAATILIKARTTA,
      sallitutTiimit: [KirjanpitajaTiimiAvaimet.MUUT, KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT],
      sallitutKirjanpitajaUidt: ['cVYOWEOwXxcTRBAxdChEK6IPM3u2'],
      description: 'Ylläpito: Päätilikartta',
    },
  },
  {
    path: 'yllapito/kirjanpitajat',
    component: KirjanpitajatComponent,
    canActivate: [YllapitoGuard, TiimiGuard, NakymaGuard],
    data: {
      nakymaAvain: LemonatorNakyma.YLLAPITO_KIRJANPITAJAT,
      sallitutTiimit: [KirjanpitajaTiimiAvaimet.MUUT, KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT],
      description: 'Ylläpito: Kirjanpitäjien nimitiedot ja sähköpostiosoitteet',
    },
  },
  {
    path: 'yllapito/kirjanpitajat/:kirjanpitajanAvain',
    component: KirjanpitajaComponent,
    canActivate: [YllapitoGuard, TiimiGuard, NakymaGuard],
    resolve: { data: KirjanpitajaComponentDataResolve },
    data: {
      nakymaAvain: LemonatorNakyma.YLLAPITO_KIRJANPITAJAT,
      sallitutTiimit: [KirjanpitajaTiimiAvaimet.MUUT, KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT],
      description: 'Ylläpito: Kirjanpitäjän tiedot',
    },
  },
  {
    path: 'yllapito/moniyritystuet',
    component: MoniyritystuetComponent,
    canActivate: [YllapitoGuard, TiimiGuard, NakymaGuard],
    data: {
      nakymaAvain: LemonatorNakyma.YLLAPITO_MONIYRITYSTUET,
      sallitutTiimit: [KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT],
      description: 'Ylläpito: Moniyritystukien listaus',
    },
  },
  {
    path: 'yllapito/moniyritystuet/:tukiAvain',
    component: MoniyritystukiComponent,
    canActivate: [YllapitoGuard, TiimiGuard, NakymaGuard],
    resolve: { data: MoniyritystukiComponentDataResolve },
    data: {
      nakymaAvain: LemonatorNakyma.YLLAPITO_MONIYRITYSTUET,
      sallitutTiimit: [KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT],
      description: 'Ylläpito: Moniyritystuen tiedot',
    },
  },
  {
    path: 'yllapito/tiimit',
    component: TiimitComponent,
    canActivate: [YllapitoGuard, TiimiGuard, NakymaGuard],
    data: {
      nakymaAvain: LemonatorNakyma.YLLAPITO_TIIMIT,
      sallitutTiimit: [KirjanpitajaTiimiAvaimet.MUUT, KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT],
      description: 'Ylläpito: Tiimit ja tiimien jäsenyydet',
    },
  },
  {
    path: 'yllapito/tiimikokonaisuudet',
    component: TiimikokonaisuudetComponent,
    canActivate: [YllapitoGuard, TiimiGuard, NakymaGuard],
    data: {
      nakymaAvain: LemonatorNakyma.YLLAPITO_TIIMIKOKONAISUUDET,
      sallitutTiimit: [KirjanpitajaTiimiAvaimet.MUUT, KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT],
      description: 'Ylläpito: Tiimikokonaisuudet',
    },
  },
  {
    path: 'yllapito/yhteisomyyntilaskut',
    component: YhteisomyyntilaskutComponent,
    canActivate: [YllapitoGuard, TiimiGuard, NakymaGuard],
    data: {
      nakymaAvain: LemonatorNakyma.YLLAPITO_YHTEISOMYYNTILASKUT,
      sallitutTiimit: [KirjanpitajaTiimiAvaimet.MUUT, KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT],
      description: 'Ylläpito: Asiakkaiden yhteisömyyntilaskut/ilmoitukset',
    },
  },
  {
    path: 'yllapito/integraatiot-holvi',
    component: YllapitoHolviComponent,
    canActivate: [YllapitoGuard, TiimiGuard, NakymaGuard],
    data: {
      nakymaAvain: LemonatorNakyma.YLLAPITO_INTEGRAATIOT_HOLVI,
      sallitutTiimit: [KirjanpitajaTiimiAvaimet.MUUT, KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT],
      description: 'Ylläpito: Holvi integraatiot - Ennakkoverolaskut',
    },
  },
  {
    path: 'yllapito/integraatiot-verohallinto',
    component: YllapitoVerohallintoComponent,
    canActivate: [YllapitoGuard, TiimiGuard, NakymaGuard],
    data: {
      nakymaAvain: LemonatorNakyma.YLLAPITO_INTEGRAATIOT_VEROHALLINTO,
      sallitutTiimit: [KirjanpitajaTiimiAvaimet.MUUT, KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT],
      description: 'Ylläpito: Verohallinto integraatiot - ALV-ilmoitukset, Veroilmoitukset, PRH-rekisteröinnit',
    },
  },
  // { path: 'yllapito/kayttoehdot', component: KayttoehdotComponent, canActivate: [YllapitoGuard, TiimiGuard], data: { description: 'Ylläpito: Julkaistut käyttöehdot' } },
  {
    path: 'yllapito/sopimukset',
    component: SopimuksetComponent,
    canActivate: [YllapitoGuard, TiimiGuard, NakymaGuard],
    data: {
      nakymaAvain: LemonatorNakyma.YLLAPITO_SOPIMUKSET,
      sallitutTiimit: [KirjanpitajaTiimiAvaimet.MUUT, KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT],
      description: 'Ylläpito: Sopimukset - toimeksiantosopimuspohjat',
    },
  },
  {
    path: 'yllapito/pankkiyhteydet',
    component: PankkiyhteydetComponent,
    canActivate: [YllapitoGuard, TiimiGuard, NakymaGuard],
    data: {
      nakymaAvain: LemonatorNakyma.YLLAPITO_PANKKIYHTEYDET,
      sallitutTiimit: [KirjanpitajaTiimiAvaimet.MUUT, KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT],
      description: 'Ylläpito: Aktiiviset pankkiyhteydet',
    },
  },
  {
    path: 'yllapito/sahkopostipohjat',
    component: EmailTemplatesComponent,
    canActivate: [YllapitoGuard, TiimiGuard, NakymaGuard],
    data: {
      nakymaAvain: LemonatorNakyma.YLLAPITO_SAHKOPOSTIPOHJAT,
      sallitutTiimit: [KirjanpitajaTiimiAvaimet.MUUT, KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT],
      description: 'Ylläpito: Sähköpostipohjat',
    },
  },
  {
    path: 'yllapito/ajastetut-tyot',
    component: YllapitoAjastetutTyotComponent,
    canActivate: [YllapitoGuard, TiimiGuard, NakymaGuard],
    data: {
      nakymaAvain: LemonatorNakyma.YLLAPITO_AJASTETUT_TYOT,
      sallitutTiimit: [KirjanpitajaTiimiAvaimet.MUUT, KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT],
      description: 'Ylläpito: Ajastetut työt',
    },
  },
  {
    path: 'yllapito/logit',
    component: LoggingComponent,
    canActivate: [YberYllapitoGuard, YllapitoGuard, TiimiGuard, NakymaGuard],
    data: {
      nakymaAvain: LemonatorNakyma.YLLAPITO_LOGIT,
      sallitutTiimit: [KirjanpitajaTiimiAvaimet.MUUT, KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT],
      description: 'Ylläpito: Logitiedot',
    },
  },
  {
    path: 'yllapito/tilastot/siirto',
    component: TilastonSiirtoTyokaluComponent,
    canActivate: [YberYllapitoGuard, TiimiGuard, NakymaGuard],
    data: { nakymaAvain: LemonatorNakyma.YLLAPITO_TILASTOJEN_SIIRTO, sallitutTiimit: ['IT'], description: 'Ylläpito: Tilastotietojen siirto' },
  },
  {
    path: 'yllapito/push-ilmoitukset',
    component: PushIlmoitusTyokaluComponent,
    canActivate: [YberYllapitoGuard, TiimiGuard, NakymaGuard],
    data: { nakymaAvain: LemonatorNakyma.YLLAPITO_PUSH_ILMOITUKSET, sallitutTiimit: ['IT'], description: 'Ylläpito: Push-ilmoitukset asiakkaille' },
  },
  {
    path: 'yllapito/llm-tyokalut',
    component: LlmKirjausehdotusTestausComponent,
    canActivate: [YllapitoGuard, TiimiGuard, NakymaGuard],
    data: {
      nakymaAvain: LemonatorNakyma.YLLAPITO_LLM_TYOKALUT,
      sallitutTiimit: [KirjanpitajaTiimiAvaimet.MUUT, KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT],
      sallitutKirjanpitajaUidt: SALLITUT_LLM_TESTAUS_UIDT,
      description: 'Ylläpito: LLM työkalut',
    },
  },
  {
    path: 'yllapito/lemonaid-viestit',
    component: LemonaidViestitComponent,
    canActivate: [YllapitoGuard, TiimiGuard, NakymaGuard],
    data: {
      nakymaAvain: LemonatorNakyma.YLLAPITO_LEMONAID_VIESTIT,
      sallitutTiimit: [KirjanpitajaTiimiAvaimet.MUUT, KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT],
      description: 'Ylläpito: Lemonaid-viestit',
    },
  },

  { path: 'kirjauduttupois', component: LoggedOutComponent },
  { path: 'kirjaudu', component: LoginComponent },

  /** Tunnistautuminen */
  { path: 'tunnistautuminen/nets-tarkista', component: TunnistautuminenNetsReturnComponent, data: { description: 'Tunnistautumisen paluu' } },
  { path: 'tilintarkastajat/tunnistaudu/:linkinAvain', component: TilintarkastajaTunnistautuminenComponent, data: { description: 'Tilintarkastajan tunnistautuminen' } },
  { path: 'tilintarkastajat/tunnistaudu', component: TilintarkastajaTunnistautuminenComponent, data: { description: 'Tilintarkastajan tunnistautuminen' } }, // Virhenäkymä, jos avain puuttuu tai tunnistautuminen epäonnistui
  { path: 'tilintarkastajat/kirjaudu', component: TilintarkastajaKirjautuminenComponent, data: { description: 'Tilintarkastajan kirjautuminen' } },
  { path: 'tilintarkastajat/aloitus', component: TilintarkastajaAloitusComponent, canActivate: [TilintarkastajaAuthGuard], data: { description: 'Tilintarkastajan aloitusnäkymä' } },

  /** Tilintarkastajan työkalut */
  {
    path: 'asiakkaat/:asiakasAvain/tilintarkastus/:vuosi/:kuukausi/:valilehti',
    component: KirjanpitoTilintarkastusComponent,
    canActivate: [TilintarkastajaAsiakasGuard],
    resolve: { data: TilintarkastajaKirjanpitoComponentDataResolve },
    data: { description: 'Tilintarkastus: vuosi/kuukausi + tiedot' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/tilintarkastus/:vuosi/:kuukausi',
    component: KirjanpitoTilintarkastusComponent,
    canActivate: [TilintarkastajaAsiakasGuard],
    resolve: { data: TilintarkastajaKirjanpitoComponentDataResolve },
    data: { description: 'Tilintarkastus: vuosi/kuukausi' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/tilintarkastus',
    component: KirjanpitoTilintarkastusComponent,
    canActivate: [TilintarkastajaAsiakasGuard],
    resolve: { data: TilintarkastajaKirjanpitoComponentDataResolve },
    data: { description: 'Tilintarkastus' },
  },
  {
    path: 'asiakkaat/:asiakasAvain/tilintarkastus/kirjanpidon-raportit/:vuosi/:kuukausi/:tyyppi',
    component: KirjanpitoRaportitStandaloneComponent,
    canActivate: [TilintarkastajaAsiakasGuard],
    resolve: { data: TilintarkastajaAsiakasComponentDataResolve },
    data: { description: 'Tilintarkastus: kirjanpito/raportit - vuosi, kuukausi, tyyppi' },
  }, // TILINTARKASTAJAT TODO: Aikarajaus

  // otherwise redirect to home
  { path: '**', redirectTo: '' },
]

export const routing = RouterModule.forRoot(appRoutes, { enableTracing: false })
